import { Component, Vue } from "vue-property-decorator";

@Component
export default class ProjectUnpublished extends Vue {
  render() {
    return (
      <svg
        width="82"
        height="82"
        viewBox="0 0 82 82"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 17C1 8.16344 8.16344 1 17 1H65C73.8366 1 81 8.16344 81 17V65C81 73.8366 73.8366 81 65 81H17C8.16344 81 1 73.8366 1 65V17Z"
          stroke="#A8A29E"
          stroke-width="1.5"
          stroke-dasharray="2 2"
        />
        <path
          d="M39.7002 34.3125L21.5 44.9287V36.4863L39.7002 25.8701V34.3125Z"
          stroke="#A8A29E"
        />
        <path
          d="M39.7002 47.6865V56.1289L21.5 45.5127V37.0703L39.7002 47.6865Z"
          stroke="#A8A29E"
        />
        <path
          d="M60.4996 46.3145L43.9 56.123V35.6846L60.4996 25.876V46.3145Z"
          stroke="#A8A29E"
        />
      </svg>
    );
  }
}
